(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const rotationInterval = 3000;

  document.querySelectorAll('[data-ib-hero-carousel], [data-ib-boxset-carousel]').forEach((carousel) => {
    if (carousel.classList.contains('ib-hero__desktop-carousel') && window.matchMedia('(max-width: 749px)').matches) return;
    const slides = Array.from(carousel.querySelectorAll('[data-ib-hero-slide]'));
    const dotsContainer = carousel.querySelector('[data-ib-hero-dots]');
    const previousButton = carousel.querySelector('[data-ib-hero-prev]');
    const nextButton = carousel.querySelector('[data-ib-hero-next]');

    if (!slides.length) return;

    let activeIndex = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
    let timer = null;
    let paused = false;
    let startX = null;

    const dots = slides.map((slide, index) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'ib-hero__carousel-dot';
      dot.setAttribute('aria-label', 'Show ' + (slide.dataset.productTitle || ('featured collection ' + (index + 1))));
      dot.setAttribute('aria-pressed', index === activeIndex ? 'true' : 'false');
      dot.addEventListener('click', () => activate(index, true));
      dotsContainer && dotsContainer.appendChild(dot);
      return dot;
    });

    const activate = (index, fromUser = false) => {
      if (!slides.length) return;
      activeIndex = (index + slides.length) % slides.length;

      slides.forEach((slide, i) => {
        const active = i === activeIndex;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        slide.tabIndex = active ? 0 : -1;
        if ('inert' in slide) slide.inert = !active;
        slide.setAttribute('aria-label', (i + 1) + ' of ' + slides.length + ': ' + (slide.dataset.productTitle || 'Featured collection'));
      });
      dots.forEach((dot, i) => dot.setAttribute('aria-pressed', i === activeIndex ? 'true' : 'false'));

      if (fromUser) restartTimer();
    };

    const stopTimer = () => {
      if (timer) window.clearTimeout(timer);
      timer = null;
    };

    const startTimer = () => {
      stopTimer();
      if (paused || reduceMotion.matches || slides.length < 2 || document.hidden) return;
      timer = window.setTimeout(() => {
        activate(activeIndex + 1, false);
        startTimer();
      }, rotationInterval);
    };

    const restartTimer = () => {
      stopTimer();
      startTimer();
    };

    if (previousButton) previousButton.addEventListener('click', () => activate(activeIndex - 1, true));
    if (nextButton) nextButton.addEventListener('click', () => activate(activeIndex + 1, true));

    carousel.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        activate(activeIndex - 1, true);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        activate(activeIndex + 1, true);
      }
    });

    carousel.addEventListener('pointerenter', () => { paused = true; stopTimer(); });
    carousel.addEventListener('pointerleave', () => { paused = false; startTimer(); });
    carousel.addEventListener('focusin', () => { paused = true; stopTimer(); });
    carousel.addEventListener('focusout', (event) => {
      if (!carousel.contains(event.relatedTarget)) {
        paused = false;
        startTimer();
      }
    });

    carousel.addEventListener('touchstart', (event) => {
      startX = event.changedTouches && event.changedTouches.length ? event.changedTouches[0].clientX : null;
      paused = true;
      stopTimer();
    }, { passive: true });

    carousel.addEventListener('touchend', (event) => {
      if (startX !== null && event.changedTouches && event.changedTouches.length) {
        const deltaX = event.changedTouches[0].clientX - startX;
        if (Math.abs(deltaX) > 48) activate(activeIndex + (deltaX < 0 ? 1 : -1), false);
      }
      startX = null;
      if (!carousel.matches(':focus-within')) {
        paused = false;
        startTimer();
      }
    }, { passive: true });

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) stopTimer();
      else startTimer();
    });

    const motionChanged = () => {
      if (reduceMotion.matches) stopTimer();
      else startTimer();
    };
    if (typeof reduceMotion.addEventListener === 'function') reduceMotion.addEventListener('change', motionChanged);
    else if (typeof reduceMotion.addListener === 'function') reduceMotion.addListener(motionChanged);

    carousel.classList.add('is-ready');
    activate(activeIndex, false);
    startTimer();
  });
})();